import React from 'react';

// eslint-disable-next-line no-unused-vars
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';

import { withMediaQueries } from 'hoc/withMediaQueries';
import { LINE_CHART_GET } from 'redux/sagas/actions/widgets';
import ChartCard from 'ui/atoms/ChartCard';
import MainFont from 'ui/typography/mainFont';

import {
  ChargingHistoryContainer,
  Date,
  HistoryChart,
  HistoryTable,
  HistoryWrapper,
  Kwh,
  ResumeTitle,
  Session
} from './style';

const chargingSessions = [
  { month: 'July', kwh: 60, session: 20 },
  { month: 'July', kwh: 60, session: 20 },
  { month: 'July', kwh: 60, session: 20 },
  { month: 'July', kwh: 60, session: 20 },
  { month: 'July', kwh: 60, session: 20 },
  { month: 'July', kwh: 60, session: 20 }
];
const ChargingHistory = () => {
  const { t } = useTranslation();

  return (
    <ChargingHistoryContainer>
      <ResumeTitle>
        <MainFont type="detailTitle">{t('charging_session_history')}</MainFont>
      </ResumeTitle>
      <HistoryWrapper>
        <HistoryTable>
          <Date>
            <MainFont type="bold">Date</MainFont>
            {chargingSessions.map((chargingSession, index) => (
              <MainFont key={index}>{chargingSession.month}</MainFont>
            ))}
          </Date>

          <Kwh>
            <MainFont type="bold">Kwh</MainFont>
            {chargingSessions.map((chargingSession, index) => (
              <MainFont key={index}>{chargingSession.kwh}</MainFont>
            ))}
          </Kwh>
          <Session>
            <MainFont type="bold">Session</MainFont>
            {chargingSessions.map((chargingSession, index) => (
              <MainFont key={index}>{chargingSession.session}</MainFont>
            ))}
          </Session>
        </HistoryTable>

        <HistoryChart>
          <ChartCard
            type={ChartCard.TYPE.LINE}
            widgetID="sampleLineChart"
            action={LINE_CHART_GET}
          />
        </HistoryChart>
      </HistoryWrapper>
    </ChargingHistoryContainer>
  );
};

ChargingHistory.propTypes = {
  // State
  // ChargingHistory
};

export default connect(
  state => {},
  dispatch => ({})
)(withMediaQueries(ChargingHistory));
